import { Box, Button, constants, Select, Text } from '@redbubble/design-system';
import { FormattedMessage, useIntl } from '@redbubble/next/intl';
import type { AppProps, CountryEntity, UserInfo } from '@redbubble/next/types';
import { usePageProps, useUserInfo } from '@redbubble/next-provider';
import { CartPageProps } from '../../../serverSideProps';

const getCountryOptions = (
  countries: CountryEntity[],
  top_countries: CountryEntity[]
) => {
  const transformCountryOption = (c: CountryEntity) => ({
    value: c.code,
    label: c.name,
  });

  const separatorOption =
    top_countries.length > 0
      ? [{ value: '', label: '', isDisabled: true }]
      : [];

  return [
    ...top_countries.map(transformCountryOption),
    ...separatorOption,
    ...countries.map(transformCountryOption),
  ];
};

export const SelectCountry = () => {
  const intl = useIntl();
  const {
    availableLocales: { countries, top_countries },
  } = usePageProps<CartPageProps & AppProps>();
  const [{ country }] = useUserInfo<UserInfo>();

  const countryOptions = getCountryOptions(countries, top_countries);

  return (
    // TODO (cy): The data-testid is used by Jest to find the <form /> element. The `getByRole('form')`
    // wil not be able to find the form. We should revisit the accessibility of this form.
    <form action="/user-settings" method="POST" data-testid="country-form">
      <Box marginBottom="m">
        {/* XXX(cy): a <label /> should be used to set the 'Shipping Country' as a label for <Select />.
            But, as of writing, the <Select /> isn't support an 'id' attribute.
        */}
        <Text type="display5" display="block" marginBottom="xs">
          <FormattedMessage defaultMessage="Shipping Country" />
        </Text>
        <Select
          name="country_code"
          fluid
          placeholder={intl.formatMessage({
            defaultMessage: 'Select your shipping country',
          })}
          defaultValue={country}
          options={countryOptions}
        />
      </Box>

      <Button type="submit" intent={constants.PRIMARY} fluid strong>
        <FormattedMessage defaultMessage="Update" />
      </Button>
    </form>
  );
};
